var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-input',{staticStyle:{"font-size":"16px","width":"100px"},on:{"change":event => _vm.changePlace(event)},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }